import React from 'react';

import { ReactComponent as LinkedIn } from '../../../images/icons/sharing/linkedin.svg';
import { ReactComponent as Email } from '../../../images/icons/sharing/mail.svg';
import { ReactComponent as Twitter } from '../../../images/icons/sharing/twitter.svg';

export const Share = [
  {
    title: 'Twitter',
    url: 'http://twitter.com/share?text=<?title> by @fullstory&url=<?url>',
    icon: <Twitter />,
  },
  {
    title: 'LinkedIn',
    url:
      'http://www.linkedin.com/shareArticle?mini=true&url=<?url>&title=<?title>&summary=<?title>&source=blog.fullstory.com',
    icon: <LinkedIn />,
  },
  {
    title: 'Email',
    url: 'mailto:?subject=<?title>&body=Article: <?url>',
    icon: <Email />,
  },
];
